
import { Component, Vue, Watch, Mixins } from 'vue-property-decorator';
import TopNavBar from '@/components/app/TopNavBar.vue';
import { HistoryData } from '@/types/history';
import DeviceMap from '@/components/devices/DeviceMap.vue';
import { DeviceInfo } from '@/types/device-info';
import { State } from 'vuex-class';
import { Debounce } from '@/modules/decorators';
import LoadableMixin from '@/mixins/LoadableMixin';
import api from '@/modules/api';
import { UserInfo } from '@/types/user-info';

@Component({
    components: {
        TopNavBar,
        DeviceMap
    },
    mixins: [LoadableMixin],
})
export default class DevicesActivity extends Mixins<LoadableMixin>(LoadableMixin) {

    locations: HistoryData[] = [];
    searchDevices: DeviceInfo[] = [];
    selectedDevices: DeviceInfo[] = [];
    devices!: DeviceInfo[];

    @State('user')
    user!: UserInfo;

    async pickMember(device: any) {
        if (device === null || typeof device === 'string') return;
        if (!this.selectedDevices.some(m => m._id === device._id)) {
            this.selectedDevices.push(device);
        }
    }

    @Debounce(500)
    async searchDevice(name: string) {
        if (!name) return;

        const alreadySelected = this.selectedDevices.find(m => m.name === name);
        if (alreadySelected) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            (this.$refs.memberSearchElemet as any).lazySearch = '';
            return;
        }
        this.searchDevices = this.devices || [];
    }

    removeDevice(device: any) {
        if (device._id) {
            this.selectedDevices = this.selectedDevices.filter(m => m.name !== device.name);
        }
    }

    protected async fetch() {
        await this.load(async () => {
            const devicesUUIDs = this.selectedDevices.map((dev) => dev.deviceUUID)
            const history = await api.getDevicesHistory(devicesUUIDs);
            this.locations = history.data;
        }, 'Unable to load device map');
    }

    @Watch('devices', { immediate: true })
    onDevicesChange(current: DeviceInfo[] | []) {
        this.searchDevices = current;
    }

    @Watch('selectedDevices', { immediate: true, deep: true })
    onSelectDevicesChange() {
        this.fetch();
    }

    async mounted() {
        this.devices = await api.loadDevices(
            this.user._id as string,
            { page: 0, perPage: 999 },
            '',
            '',
        );
        this.searchDevices = this.devices;
    }
}
